import React from 'react';
import DisputeMediaSection from './DisputeMediaSection';

const ChatMessagesList = ({
  ticketDescription,
  customerMedia,
  workerProofs,
  baseUrlForFile,
  setPreviewImage,
  setPreviewVideo,
  messages,
  bottomRef
}) => {
  return (
    <div className="wc-messages">

      {ticketDescription && (
        <div className="cc-ticket-box">
          🟡 Ticket: {ticketDescription}
        </div>
      )}

      {/* MEDIA SECTION */}
      <DisputeMediaSection
        customerMedia={customerMedia}
        workerProofs={workerProofs}
        baseUrlForFile={baseUrlForFile}
        setPreviewImage={setPreviewImage}
        setPreviewVideo={setPreviewVideo}
      />

      {messages.map((msg, i) => {
        if (!msg) return null;   // ✅ CRASH STOP

        const isWorker = msg.sender === 'worker';
        const isAdmin  = msg.sender === 'admin';
        const isSystem = msg.sender === 'system';

        return (
          <div
            key={msg.id || i}
            className={`wc-bubble 
              ${isWorker ? 'wc-right' : ''} 
              ${isAdmin ? 'wc-admin' : ''} 
              ${isSystem ? 'wc-system' : ''} 
              ${!isWorker && !isAdmin && !isSystem ? 'wc-left' : ''}
            `}
          >
            {!isSystem && (
              <small className="wc-sender">
                {msg.sender === 'worker'
                  ? 'You'
                  : msg.sender === 'admin'
                  ? 'Admin'
                  : 'Customer'}
              </small>
            )}

            <p>{msg.message}</p>
          </div>
        );
      })}

      <div ref={bottomRef} />
    </div>
  );
};

export default ChatMessagesList;